<template>
  <div ref="animationNode">
    <slot />
  </div>
</template>

<script>
// 添加
const addKeyFrames = (runkeyframes) => {
  // 创建style标签
  const style = document.createElement('style');
  // 设置style属性
  style.type = 'text/css';
  // 将 keyframes样式写入style内
  style.innerHTML = runkeyframes;
  // 将style样式存放到head标签
  document.getElementsByTagName('head')[0].appendChild(style);
};
// 获取
const getKeyFrames = (name) => {
  let animation = null;
  // 获取所有的style
  const ss = document.styleSheets;
  for (let i = 0; i < ss.length; ++i) {
    const item = ss[i];
    if (item.cssRules[0] && item.cssRules[0].name && item.cssRules[0].name === name) {
      animation = {};
      animation.cssRule = item.cssRules[0];
      animation.styleSheet = ss[i];
      animation.index = 0;
    }
  }
  return animation;
};
// 更新
const updataKeyFrames = (name, runkeyframes) => {
  const oldVal = getKeyFrames(name);
  // 存在,更新即可
  if (oldVal) {
    oldVal.styleSheet.deleteRule(0);
    addKeyFrames(runkeyframes);
  } else {
    addKeyFrames(runkeyframes);
  }
};

const createKeyFrames = (name, type, startValue, toValue) => {
  let runkeyframes = ` @keyframes ${name}`;
  // 这里类型还不确定有哪些，后续慢慢添加,或者直接重写
  switch (type) {
    case 'rotate': {
      runkeyframes += `{
                        0%{
                            transform: rotate(${startValue}deg);
                        }
                        100%{
                            transform: rotate(${toValue}deg);
                        }
                      }`;
      break;
    }
    default: '';
  }
  return runkeyframes;
};

// todo animation
export default {
  name: 'Animation',
  props: {
    playing: {
      type: Boolean,
      default: () => false,
    },
    actions: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      style: {},
      animationTypes: ['rotate'],
    };
  },
  watch: {
    actions() {
      // todo
    },
    playing(newVal, oldVal) {
      // 监控动画状态，是否进行动画
      if (!oldVal && newVal) {
        this.start();
      } else if (oldVal && !newVal) {
        this.pause();
      }
    },
  },
  beforeDestroy() {
    this.destroy();
  },
  beforeMount() {
  },
  mounted() {
    this.create();
    const { playing } = this.$props;
    if (playing) {
      this.start();
    }
  },
  methods: {
    create() {
      const { transform } = this.actions;
      const keyframes = createKeyFrames(`animation${this._uid}`, Object.keys(transform)[0], transform[Object.keys(transform)[0]].startValue, transform[Object.keys(transform)[0]].toValue);
      updataKeyFrames(this._uid, keyframes);
      this.$refs.animationNode.setAttribute('style', `animation: animation${this._uid} ${transform[Object.keys(transform)[0]].duration / 1000}s infinite linear;`);
    },
    start() {
      this.$refs.animationNode.style['animation-play-state'] = 'running';
    },
    pause() {
      this.$refs.animationNode.style['animation-play-state'] = 'paused';
    },
    destroy() {},
  },
};
</script>
